'use client';

import type { Billing } from './data';

const OPTIONS: { value: Billing; label: string }[] = [
  { value: 'monthly', label: 'Monthly' },
  { value: 'annual', label: 'Annual' },
];

/** Monthly/Annual segmented pill control for the pricing tiers. */
export default function BillingToggle({
  value,
  onChange,
}: {
  value: Billing;
  onChange: (value: Billing) => void;
}) {
  return (
    <div
      role="radiogroup"
      aria-label="Billing period"
      className="inline-flex items-center gap-1 rounded-full border border-line bg-surface p-1 shadow-ref"
      onKeyDown={(e) => {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault();
          onChange(value === 'monthly' ? 'annual' : 'monthly');
        }
      }}
    >
      {OPTIONS.map((opt) => {
        const active = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(opt.value)}
            className={`inline-flex items-center rounded-full px-4 py-1.5 text-sm font-semibold transition-colors duration-150 ${
              active ? 'bg-brand-600 text-white' : 'text-muted hover:text-ink'
            }`}
          >
            {opt.label}
            {opt.value === 'annual' && (
              <span
                className={`ml-1.5 rounded-full px-1.5 py-px text-[11px] font-semibold ${
                  active ? 'bg-white/20 text-white' : 'bg-brand-600/10 text-brand-600'
                }`}
              >
                Save 16%
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
